import { Home, TrendingUp, Shield, Users, User } from "lucide-react";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export const navTabs = [
  { path: "/", labelKey: "bottomNav.home", icon: Home },
  { path: "/ai-trading", labelKey: "bottomNav.aiTrading", icon: TrendingUp },
  { path: "/custody", labelKey: "bottomNav.custody", icon: Shield },
  { path: "/team", labelKey: "bottomNav.team", icon: Users },
  { path: "/profile", labelKey: "bottomNav.profile", icon: User },
];

const PRIMARY = "#22c55e";
const INACTIVE = "#4b5563";

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 flex items-stretch"
      style={{
        background: "rgba(6,8,16,0.94)",
        backdropFilter: "blur(24px) saturate(1.2)",
        borderTop: "1px solid rgba(100,140,200,0.06)",
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
      }}
    >
      {navTabs.map(tab => {
        const isActive = location.pathname === tab.path;
        const Icon = tab.icon;
        return (
          <button
            key={tab.path}
            type="button"
            onClick={() => navigate(tab.path)}
            className="flex-1 flex flex-col items-center justify-center py-3 gap-1.5 transition-all duration-200 relative"
            style={{ color: isActive ? PRIMARY : INACTIVE }}
          >
            {isActive && (
              <div
                className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full"
                style={{ background: PRIMARY }}
              />
            )}
            <motion.div
              className="relative flex flex-col items-center"
              whileTap={{ scale: 0.8, y: 2 }}
              animate={
                isActive
                  ? { scale: [0.85, 1.18, 0.96, 1], y: [2, -3, 0, 0] }
                  : { scale: 1, y: 0 }
              }
              transition={
                isActive
                  ? { duration: 0.4, ease: "easeOut" }
                  : { duration: 0.15 }
              }
              key={`nav-icon-${tab.path}-${isActive}`}
            >
              <Icon size={24} strokeWidth={isActive ? 2.5 : 1.8} />
            </motion.div>
            <motion.span
              className="text-xs"
              animate={
                isActive
                  ? { scale: [0.9, 1.08, 1], opacity: [0.6, 1, 1] }
                  : { scale: 1, opacity: 1 }
              }
              transition={
                isActive
                  ? { duration: 0.3, ease: "easeOut" }
                  : { duration: 0.15 }
              }
              key={`nav-label-${tab.path}-${isActive}`}
              style={{ fontWeight: isActive ? 600 : 400 }}
            >
              {t(tab.labelKey)}
            </motion.span>
          </button>
        );
      })}
    </nav>
  );
}
